// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 523797145
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Team } from './models/security/team';
import { UserSummary } from './models/security/usersummary';
import { ClientSummary } from './models/client/clientsummary';
import { TeamUser } from './models/security/teamuser';

export interface getUsersByTeamId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getClientsByTeamId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

@Injectable({
  providedIn: 'root',
})
export class TeamsApiService {
  constructor(protected http: HttpClient) {}

  getAllTeams(criteria?: SmartListCriteria): Observable<SmartListResult<Team>> {
    let url = environment.chiliSauceApiRoot + `/api/Teams`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Team>>(url);
  }

  addTeam(newTeam: Team): Observable<Team> {
    const url = environment.chiliSauceApiRoot + `/api/Teams`;
    return this.http.post<Team>(url, newTeam);
  }

  getTeamById(teamGuid: string): Observable<Team> {
    const url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}`;
    return this.http.get<Team>(url);
  }

  updateTeam(team: Team, teamGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}`;
    return this.http.put<any>(url, team);
  }

  deleteTeam(teamGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}`;
    return this.http.delete(url);
  }

  getUsersByTeamId(
    teamGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getUsersByTeamId_Filter>
  ): Observable<SmartListResult<UserSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}/users`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<UserSummary>>(url, { params: params });
  }

  updateUsersForTeamId(teamGuid: string, ids: string[]): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}/users`;
    return this.http.put<any>(url, ids);
  }

  getClientsByTeamId(
    teamGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getClientsByTeamId_Filter>
  ): Observable<SmartListResult<ClientSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}/clients`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ClientSummary>>(url, {
      params: params,
    });
  }

  updateClientsForTeamId(teamGuid: string, ids: string[]): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Teams/${teamGuid}/clients`;
    return this.http.put<any>(url, ids);
  }

  getTeamsByUserId(userId: string): Observable<TeamUser[]> {
    const url = environment.chiliSauceApiRoot + `/api/Teams/user/${userId}`;
    return this.http.get<TeamUser[]>(url);
  }
}
